import moment from 'moment';
import React from 'react';
import MobileTransferIcon from '../../images/stock-type-icons/MobileTransfer.png';
import MobileIcon from '../../images/stock-type-icons/Mobile.png';
import PhysicalIcon from '../../images/stock-type-icons/Physical.png';
import PrintAtHomeIcon from '../../images/stock-type-icons/PrintAtHome.png';

const stockTypes = {
  Electronic: {
    icon: MobileIcon,
    text: 'Mobile',
  },
  'Electronic Instant Download': {
    icon: PrintAtHomeIcon,
    text: 'Print-at-home',
  },
  FedEx: {
    icon: PhysicalIcon,
    text: 'Physical',
  },
  Pickup: {
    icon: PhysicalIcon,
    text: 'Physical',
  },
  UPS: {
    icon: PhysicalIcon,
    text: 'Physical',
  },
  'Royal Mail': {
    icon: PhysicalIcon,
    text: 'Physical',
  },
  'Deutsche Post': {
    icon: PhysicalIcon,
    text: 'Physical',
  },
  MobileId: {
    icon: MobileIcon,
    text: 'Mobile',
  },
  'Mobile Ticket': {
    icon: MobileTransferIcon,
    text: 'Mobile Transfer',
  },
  'External Transfer': {
    icon: MobileTransferIcon,
    text: 'Mobile Transfer',
  },
  Courier: {
    icon: PhysicalIcon,
    text: 'Physical',
  },
  'Mobile Ticket Instant': {
    icon: MobileTransferIcon,
    text: 'Mobile Transfer',
  },
  'MobileId Non Instant': {
    icon: MobileIcon,
    text: 'Mobile',
  },
  'Electronic and Mobile Ticket': {
    icon: MobileIcon,
    text: 'Mobile',
  },
  'Electronic and Mobile Ticket Instant': {
    icon: MobileTransferIcon,
    text: 'Mobile Transfer',
  },
  LocalDelivery: {
    icon: PhysicalIcon,
    text: 'Physical',
  },
};

const TYPE = 'type';
const NUMBER_TYPE = 'Numbers';
const S_LETTER_TYPE = 'Single letters';
const D_LETTER_TYPE = 'Double letters';
const T_LETTER_TYPE = 'Triple letters';
const LOWER_THAN_OR_EQUAL = 'row should be lower than or equal to high row';
const GREATER_THAN_OR_EQUAL = 'row should be greater than or equal to low row';
const singleLetterPattern = /^[a-zA-Z]{1}$/;
const doubleLetterPattern = /^[a-zA-Z]{2}$/;
const tripleLetterPattern = /^[a-zA-Z]{3}$/;
const onlyNumberPattern = /^\d+$/;

export const INVALID_RANGE = 'invalid-range';
export const REQUIRED_FIELD = 'required-field';
export const INVALID_ZONE = 'invalid-zone';

/**
 * Returns only numbers
 * @param {string} value
 * @returns {number}
 */
export const onlyNumbers = (value = '') => {
  const pattern = /\D/g;
  return Number(value.replace(pattern, ''));
};

/**
 * Format numbers with decimal
 * @param {string|number} value
 * @param {number} decimals
 * @param {boolean} allowEmpty
 * @returns {number}
 */
export const formatFloat = (value = '', decimals = 2, allowEmpty) => {
  const pattern = /(\d)(?=(\d{3})+(?!\d))/g;

  if (allowEmpty && value === '') return '';

  return Number(value)
    .toFixed(decimals)
    .replace(pattern, '$1');
};

/**
 * dateFormatter Returns a formatted date with the description of the time has been passed or when it will happen
 * @param {string} date Datetime to be formatted
 * @param {boolean} past Boolean to know if you want the past time or incoming
 */
export const dateFormatter = (date, past = true) => {
  if (date === null) {
    return 'no dates found';
  }
  const currDate = moment(new Date(date.concat(' UTC')));
  const now = moment(new Date());
  let duration = new Date();
  if (past) {
    duration = moment.duration(now.diff(currDate));
  } else {
    duration = moment.duration(currDate.diff(now));
  }
  function splitTime(numberOfHours) {
    const days = Math.floor(numberOfHours / 24);
    const remainder = numberOfHours % 24;
    const hours = Math.floor(remainder);
    const minutes = Math.floor(60 * (remainder - hours));
    return `${JSON.stringify(days)} day ${JSON.stringify(hours)} hr ${JSON.stringify(minutes)} minutes`;
  }
  function timeConvert(info) {
    const hrs = parseInt(Number(info), 0);
    const min = Math.round((Number(info) - hrs) * 60);
    if (hrs > 24) {
      return splitTime(info);
    }
    if (hrs === 0) {
      if (min < 2) {
        return 'Just Now';
      }
      return `${JSON.stringify(min)} minutes`;
    }
    return `${JSON.stringify(hrs)} hr ${JSON.stringify(min)} minutes`;
  }
  return timeConvert(duration.asHours().toFixed(2));
};

/**
 *  Handles market place include exclude selections
 * @param {object} marketPlace setup of market places
 * @param {object} current current market place selected
 * @return {object} returns market place updated
 */
export const handleMarketplace = (marketPlace, current) => {
  const [key, value] = current.split('_');
  const prefix = value[0];
  const newMarketplace = { ...marketPlace };
  const hasPLus = Object.keys(newMarketplace).filter(attr => newMarketplace[attr].value.split('_')[1][0] === '+');

  if (hasPLus.length) {
    newMarketplace[hasPLus[0]].value = `${newMarketplace[hasPLus[0]].name}_${newMarketplace[hasPLus[0]].name}`;
  }

  if (prefix === '+') {
    Object.keys(newMarketplace).forEach(d => {
      newMarketplace[d].value = `${newMarketplace[d].name}_${newMarketplace[d].name}`;
    });
  }

  newMarketplace[key].value = `${key}_${value}`;
  return newMarketplace;
};

/**
 *  Handles market place include exclude selections
 * @param {object} marketPlace setup of market places
 * @param {object} current current market place selected
 * @return {object} returns market place updated
 */
export const handleMarketplaceBasedOnSelection = (marketPlace, include, exclude) => {
  const newMarketplace = { ...marketPlace };

  if (include && Array.isArray(include) && include.length > 0) {
    Object.keys(marketPlace).forEach(d => {
      newMarketplace[d].value = include.includes(newMarketplace[d].name)
        ? `${newMarketplace[d].name}_${newMarketplace[d].includePhrase}`
        : `${newMarketplace[d].name}_${newMarketplace[d].name}`;
    });
    return newMarketplace;
  }
  if (exclude && Array.isArray(exclude) && exclude.length > 0) {
    Object.keys(marketPlace).forEach(d => {
      newMarketplace[d].value = exclude.includes(newMarketplace[d].name)
        ? `${newMarketplace[d].name}_${newMarketplace[d].ignorePhrase}`
        : `${newMarketplace[d].name}_${newMarketplace[d].name}`;
    });
    return newMarketplace;
  }

  Object.keys(newMarketplace).forEach(d => {
    newMarketplace[d].value = `${newMarketplace[d].name}_${newMarketplace[d].name}`;
  });

  return newMarketplace;
};

/**
 *  Handles market place include exclude selections
 * @param {object} marketPlace setup of market places
 * @param {object} current current market place selected
 * @return {object} returns market place updated
 */
export const retrieveMarketplaceInclusionsExclusions = marketPlace => {
  const hasPlus = Object.keys(marketPlace).filter(attr => marketPlace[attr].value.split('_')[1][0] === '+');
  const hasMinus = Object.keys(marketPlace).filter(attr => marketPlace[attr].value.split('_')[1][0] === '-');
  return { inclusions: hasPlus, exclusions: hasMinus };
};

/**
 * verifyZoneTypeDataOnChange Returns true or false verifying the type of the value inserted
 * @param {string} type zone type to be validated (Numbers || Single letters|| Double letters || Triple letters)
 * @param {string} value value to be validated
 */
export const verifyZoneTypeDataOnChange = (type, value) => {
  if (!value) return true;
  switch (type) {
    case NUMBER_TYPE:
      return !!value.match(onlyNumberPattern);
    case S_LETTER_TYPE:
      return !!value.match(singleLetterPattern);
    case D_LETTER_TYPE:
      return value.match(singleLetterPattern) || value.match(doubleLetterPattern);
    case T_LETTER_TYPE:
      return value.match(singleLetterPattern) || value.match(doubleLetterPattern) || value.match(tripleLetterPattern);
    default:
      return false;
  }
};

/**
 * verifyZoneTypeData Returns true or false verifying the type of the value inserted
 * @param {string} type zone type to be validated (Numbers || Single letters|| Double letters || Triple letters)
 * @param {string} value value to be validated
 */
export const verifyZoneTypeData = (type, value) => {
  if (!value) return true;
  switch (type) {
    case NUMBER_TYPE:
      return !!value.match(onlyNumberPattern);
    case S_LETTER_TYPE:
      return !!value.match(singleLetterPattern);
    case D_LETTER_TYPE:
      return !!value.match(doubleLetterPattern);
    case T_LETTER_TYPE:
      return !!value.match(tripleLetterPattern);
    default:
      return false;
  }
};

/**
 * verifyZoneTypeRange Returns a formatted date with the description of the time has been passed or when it will happen
 * @param {string} type zone type to be validated (Numbers || Single letters|| Double letters || Triple letters)
 * @param {string} low value to be validated and should be lower than high
 * @param {string} high value to be validated and should be higher than low
 */
export const verifyZoneTypeRange = (type, low, high) => {
  if (!low || !high) return true;
  switch (type) {
    case NUMBER_TYPE:
      return Number(low) < Number(high);
    case S_LETTER_TYPE:
      return high >= low;
    case D_LETTER_TYPE:
      return high >= low;
    case T_LETTER_TYPE:
      return low.toLowerCase() < high.toLowerCase();
    default:
      return false;
  }
};

/**
 * formattedValue Returns a formatted date with the description of the time has been passed or when it will happen
 * @param {string} inputType type of the input to check if is not 'type'
 * @param {string} inputType zone type to be validated (Numbers || Single letters|| Double letters || Triple letters)
 * @param {string} value value to be formatted
 */
export const formattedValue = (inputType, zoneType, value) => {
  if (!value) return value;
  if (inputType !== TYPE) {
    if (zoneType === NUMBER_TYPE) {
      return Number(value);
    }
    return value.toUpperCase();
  }
  return value;
};

/**
 * requiredFieldError Returns a string that says the field (high or low) is required
 * @param {string} rowType type of row in the range (either high or low)
 */
export const requiredFieldError = rowType => {
  if (rowType) {
    return `${rowType} row is required`;
  }
  throw new Error('Row type not provided');
};

/**
 * invalidRangeError Returns a string that describes why the range is incorrect for either a high or low input
 * @param {string} rowType type of row in the range (either high or low)
 */
export const invalidRangeError = rowType => {
  if (rowType) {
    return `Invalid range, ${rowType} ${rowType === 'low' ? LOWER_THAN_OR_EQUAL : GREATER_THAN_OR_EQUAL}`;
  }
  throw new Error('Row type not provided');
};

/**
 * invalidZoneError Returns a string that promps the user to select a valid zone
 */
export const invalidZoneError = () => {
  return `Please select a valid zone`;
};

/**
 * buildErrorMessage Returns the correct error message string based on the row and error types
 * @param {string} rowType type of row in the range (either high or low)
 * @param {string} errorType type of error string to build
 */
export const buildErrorMessage = (errorType, rowType) => {
  switch (errorType) {
    case REQUIRED_FIELD:
      return requiredFieldError(rowType);
    case INVALID_RANGE:
      return invalidRangeError(rowType);
    case INVALID_ZONE:
      return invalidZoneError();
    default:
      return '';
  }
};

/**
 * buildError returns the correct error object based on the row and error types
 * @param {string} rowType type of row in the range (either high or low)
 * @param {string} errorType type of error string to build
 */
export const buildError = (errorType, rowType) => {
  return {
    errorType,
    rowType,
    errorMessage: buildErrorMessage(errorType, rowType),
  };
};

/**
 * getErrorMessage returns the correct error message in errorFlags based on zoneNames and rowType
 * @param {object} errorFlags object that contains all the current errors to display
 * @param {string} zoneName name of the zone for which to display the error message
 * @param {string} rowType type of row in the range (either high or low)
 */
export const getErrorMessage = (errorFlags, zoneName, rowType) => {
  const error = errorFlags[zoneName];
  return error && error.rowType === rowType ? error.errorMessage : '';
};

const styles = {
  iconWrapper: { display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 1 },
  icon: { width: 'auto', height: 22 },
};

/**
 * getStockTypeIcons returns a div with the different stock type options for a ticket
 * @param {array} stockTypesToRender array of the names of the stocktypes available for the ticket
 */
export const getStockTypeIcons = stockTypesToRender => {
  if (stockTypesToRender.length) {
    return (
      <div style={styles.iconWrapper}>
        {stockTypesToRender.map(stockTypeToRender => {
          const stockTypeObject = stockTypes[stockTypeToRender];
          if (stockTypeObject) {
            const { icon, text } = stockTypeObject;
            return <img src={icon} style={styles.icon} alt={text} title={text} />;
          }
          return null;
        })}
      </div>
    );
  }
  return null;
};

/**
 *
 * @param {string} email
 */
export const isEmail = (email = '') => {
  // eslint-disable-next-line no-useless-escape
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export default {
  onlyNumbers,
  formatFloat,
  handleMarketplace,
};
